import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./STDTDModelerGlobal.styles";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import STDTDModelerGlobalFiltersAndReports from "./STDTDModelerGlobalFiltersAndReports.component";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";
import { ApprovalProvider } from "../../../context/ApprovalContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const STDTDModelerGlobal = ({ toCompare = false } = {}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <TreasuryKRISummaryProvider>
            <ApprovalProvider>
              <STDTDModelerGlobalFiltersAndReports
                toSave={true}
                toCompare={toCompare}
              />
            </ApprovalProvider>
          </TreasuryKRISummaryProvider>
        </HedgeRatioProvider>

        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default STDTDModelerGlobal;
